import { createMuiTheme } from '@material-ui/core';

import { appConfig } from '../config/app';

export const theme = createMuiTheme({
  shape: {
    borderRadius: 8,
  },
  palette: appConfig?.PALETTE,
  typography: appConfig?.TYPOGRAPHY,
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 8,
        textTransform: 'none',
      },
      contained: {
        '&.Mui-disabled': {
          color: '#FFF',
          backgroundColor: '#6A6A6A',
        },
      },
    },
    MuiButtonBase: {
      root: {
        color: appConfig?.PALETTE.primary.main,
      },
    },
  },
});
